import { MarketId } from '@velocity-exchange/common';
import { MarketType } from '@velocity-exchange/sdk';
import useGetTickSizeForMarket, {
	getTickSizeDecimalPlaces,
} from 'src/hooks/useGetTickSizeForMarket';
import { getEffectivePriceDecimals } from 'src/constants/marketDecimalConfig';
import useMarkPrice from 'src/hooks/useMarkPrice';
import TextButton from 'src/components/primitives/TextButton/TextButton';

interface Props {
	marketIndex: number;
	handleChange: (value: string) => void;
	marketType: MarketType;
	baseAssetSymbol: string;
}

export default function PriceInputMidButton({
	marketIndex,
	handleChange,
	marketType,
	baseAssetSymbol,
}: Props) {
	const marketId = new MarketId(marketIndex, marketType);
	const currentMarkPrice = useMarkPrice(marketId);
	const getTickSizeForMarket = useGetTickSizeForMarket();
	const tickSize = getTickSizeForMarket(marketId);

	// The button writes the price box directly, so it renders the mark at the
	// digits the field's own mask admits: the tick intersected with the market's
	// display config, which is the tighter of the two.
	const fractionDigits = getEffectivePriceDecimals(
		baseAssetSymbol,
		getTickSizeDecimalPlaces(tickSize)
	);

	return (
		<TextButton
			size="md"
			variant="tertiary"
			onClick={() => handleChange(currentMarkPrice.toFixed(fractionDigits))}
		>
			Mid
		</TextButton>
	);
}
